module.exports = __webpack_public_path__ + "justtteddy.jpg?ae78da485eed6aedd031b607813f799f";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/justtteddy.jpg
// module id = 661
// module chunks = 0